// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"07ab7c0c","551":"93795363","749":"79345bcf","903":"a0c2e375"}[chunkId] + ".chunk.js";
};